/**
 * created by mleitzell on 7/17/17.
 */
import PromptInput from "common/widgets/PromptList/PromptInput";
import Link from "common/widgets/Link/Link";

export default PromptInput.extend({

    options: {
        name: "LinkPromptInput",
        template: "<a class='linkPrompt' href='' target='_blank'></a>"
    },

    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);

        this.widget = new Link(this.input, {});

        this.noUrlNotification = $.proxy(this.noUrlNotification, this);
        this._updateUrl();
        this._updateLabel();

        this.refresh();
    },

    _updateUrl: function() {
        var url = this.options.model.url;
        if (url && url.indexOf("://") === -1) {
            url = "http://" + url;
        }
        this.options.model.url = this.options.model.value = url;
        this._updateUrlHref();
    },

    _updateUrlHref: function() {
        this.input.off("click", this.noUrlNotification);
        if (!this.options.model.url) {
            this.input.removeAttr("href");
            this.input.on("click", this.noUrlNotification);
        } else {
            this.input.attr("href", this.options.model.url);
        }
    },

    /**
     * Override to handle notification when a link is clicked but there is no url to navigate to
     * @returns {boolean}
     * @private
     */
    noUrlNotification: $.noop,

    _updateLabel: function() {
        this.input.text(this.options.model.label);
    },

    updateWidgetValue: function(value) {
        this.options.model.url = value;
        this._updateUrl();
    },

    value: function() {
        return this.options.model.url;
    },

    text: function() {
        return this.input.text();
    },

    /**
     * Override
     */
    readonly: function(val) {
        PromptInput.fn._readonly(val);
    },

    /**
     * Override
     */
    enable: function(val) {
        this.input.toggleClass("disabled", val !== true);
    },

    /**
     * Overrdie
     */
    canFocusWhenPromptListReadonly: function() {
        return true;
    }
});
